import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Sparkles, X, RefreshCw, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { catMeta, releaseItems } from "../config/releaseCategories";

export function WhatsNewModal({ info, onClose }) {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [closing, setClosing] = useState(false);
  const rel = info?.release;
  if (!rel) return null;

  const mandatory = Boolean(info?.mandatory || rel?.mandatory);
  const items = releaseItems(rel);

  const dismiss = async () => {
    if (closing) return;
    setClosing(true);
    try { await api.markVersionSeen(); } catch { /* noop */ }
    onClose();
  };

  const reload = async () => {
    try { await api.markVersionSeen(); } catch { /* noop */ }
    if ("caches" in window) { try { const ks = await caches.keys(); await Promise.all(ks.map((k) => caches.delete(k))); } catch { /* noop */ } }
    window.location.reload();
  };

  const seeAll = async () => { try { await api.markVersionSeen(); } catch { /* noop */ } onClose(); nav("/nouveautes"); };

  return (
    <div className="modal-overlay" onClick={mandatory ? undefined : dismiss} data-testid="whats-new-modal" style={{ zIndex: 300 }}>
      <div className="modal-card gold-border" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 560, maxHeight: "min(760px, calc(100vh - 48px))", overflowY: "auto" }}>
        {!mandatory && <button className="modal-close" onClick={dismiss} data-testid="whats-new-close"><X size={18} /></button>}
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 6 }}>
          <div style={{ width: 46, height: 46, borderRadius: 14, background: "rgba(var(--gold-rgb),.16)", border: "1px solid var(--border-gold)", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--gold)" }}>
            <Sparkles size={22} />
          </div>
          <div>
            <h3 style={{ margin: 0, fontSize: 19, fontWeight: 800 }}>
              {mandatory ? "Mise à jour requise" : <>Nouvelle <span className="gold">version</span></>}
            </h3>
            <div style={{ fontSize: 12.5, color: "var(--muted)" }}>
              <span className="badge badge-gold" style={{ marginRight: 8 }} data-testid="whats-new-version">PROGÈRE PUNCH v{rel.version}</span>{rel.date}
            </div>
          </div>
        </div>
        {rel.title && <p style={{ fontSize: 15, fontWeight: 700, margin: "12px 0 4px" }}>{rel.title}</p>}
        {mandatory && <p style={{ color: "var(--red)", fontSize: 13, margin: "6px 0 12px", fontWeight: 600 }}>Une mise à jour importante de sécurité est disponible. Veuillez actualiser PROGÈRE PUNCH afin de continuer.</p>}
        {!mandatory && <p style={{ color: "var(--muted)", fontSize: 13, margin: "8px 0 16px", lineHeight: 1.5 }}>{t("whatsNew.subtitle")}</p>}

        <ul style={{ listStyle: "none", padding: 0, margin: "0 0 20px", display: "flex", flexDirection: "column", gap: 10 }} data-testid="whats-new-notes">
          {items.map((it, i) => {
            const m = catMeta(it.category);
            return (
              <li key={i} className="progere-release-item" style={{ display: "flex", gap: 11, alignItems: "flex-start", padding: "11px 12px", background: "var(--head-bg)", border: "1px solid var(--border-soft)", borderRadius: 8 }}>
                <span style={{ marginTop: 1, color: m.color, flexShrink: 0 }}><m.Icon size={17} /></span>
                <div style={{ flex: 1 }}>
                  <span className="badge" style={{ fontSize: 9.5, fontWeight: 800, letterSpacing: .5, color: m.color, background: "transparent", border: `1px solid ${m.color}`, padding: "1px 6px", marginRight: 8 }}>{m.badge}</span>
                  <span style={{ fontSize: 13.5, lineHeight: 1.45 }}>{it.text}</span>
                </div>
              </li>
            );
          })}
        </ul>

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          {mandatory ? (
            <button className="btn btn-gold" style={{ flex: 1, justifyContent: "center" }} onClick={reload} data-testid="whats-new-update"><RefreshCw size={15} /> Mettre à jour maintenant</button>
          ) : (
            <>
              <button className="btn btn-gold" style={{ flex: 1, justifyContent: "center" }} onClick={dismiss} data-testid="whats-new-ok">{t("whatsNew.gotIt")}</button>
              <button className="btn btn-outline" style={{ justifyContent: "center" }} onClick={seeAll} data-testid="whats-new-seeall">Voir toutes les nouveautés <ArrowRight size={14} /></button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
